import { useEffect, useRef, useState } from 'react';
import { changeAccountStatus, getAccounts } from '../../../../../../services/settings/accounting';
import { toast } from 'react-toastify';

const useAccounts = () => {
	const [isOpenAccountsModal, setIsOpenAccountsModal] = useState(false);
	const isFirstRender = useRef(true);
	const [searchText, setSearchText] = useState('');
	const [loader, setLoader] = useState(false);
	const [isShowToast, setShowToast] = useState(false);
	const [isOpenDeactivateAccountModal, setIsOpenDeactivateAccountModal] = useState(false);
	const [isOpenDeactivateConfirmAccountModal, setIsOpenDeactivateConfirmAccountModal] =
		useState(false);
	const [isOpenActivateAccountModal, setIsOpenActivateAccountModal] = useState(false);
	const [accounts, setAccounts] = useState({
		data: [],
		totalPages: 0,
		currentPage: 1,
	});
	const [sortDirection, setSortDirection] = useState({ id: 'asc' });
	const [params, setParams] = useState({
		search: null,
		status: null,
		page: 1,
		pageSize: 20,
		order_by: 'created_at',
		sort_by: 'desc',
	});

	const sortDataList = (param) => {
		const newDirection = sortDirection[param.order_by] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.order_by]: newDirection });

		setParams((prev) => ({
			...prev,
			order_by: param.order_by,
			sort_by: newDirection,
		}));
	};

	const handleDeactivateAccount = async (id) => {
		try {
			const body = {
				status: 0,
			};
			const res = await changeAccountStatus(id, body);
			if (res.success) {
				toast.success(res.message);
				setIsOpenDeactivateConfirmAccountModal(false);
				getAccountList();
			} else {
				toast.error(res.message || 'something went wrong!');
			}
		} catch (err) {
			toast.error(err.message || 'Something went wrong!');
		}
	};

	const getAccountList = async () => {
		try {
			setLoader(true);
			const { accounts, total_pages, page } = await getAccounts(params);
			if (accounts) {
				const list = mappedTableData(accounts);
				setAccounts((prev) => ({
					...prev,
					data: list,
					totalPages: total_pages,
					currentPage: page,
				}));
			}
		} catch (error) {
		} finally {
			setLoader(false);
		}
	};

	function mappedTableData(data) {
		return data?.map((ele) => {
			return {
				id: ele.account_id,
				account_name: ele.account_name || 'N/A',
				account_code: ele?.account_code || 'N/A',
				account_type: ele?.account_type || 'N/A',
				category: ele?.category || 'N/A',
				description: ele?.description || '',
				source: ele?.source || '',
				status: ele?.status,
			};
		});
	}

	const showMessage = () => {
		setShowToast(true);

		setTimeout(() => {
			setShowToast(false);
		}, 3000); // auto hide after 3 sec
	};

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return; // ⛔ skip first render
		}
		const debounceTimer = setTimeout(() => {
			setParams((prev) => ({
				...prev,
				search: searchText,
			}));
		}, 500); // ⏱ debounce delay (ms)

		return () => clearTimeout(debounceTimer);
	}, [searchText]);

	useEffect(() => {
		getAccountList();
	}, [params]);

	return {
		setIsOpenAccountsModal,
		isOpenAccountsModal,
		params,
		setParams,
		setSearchText,
		searchText,
		sortDataList,
		sortDirection,
		setLoader,
		loader,
		accounts,
		isShowToast,
		setShowToast,
		showMessage,
		setIsOpenDeactivateConfirmAccountModal,
		isOpenDeactivateConfirmAccountModal,
		setIsOpenDeactivateAccountModal,
		isOpenDeactivateAccountModal,
		handleDeactivateAccount,
		setIsOpenActivateAccountModal,
		isOpenActivateAccountModal,
		getAccountList,
	};
};
export default useAccounts;
